<template>
  <div class="cnt ">
		<!-- <v-btn-toggle -->
		<!-- 	style="align-self: stretch" -->
		<!-- 	v-model="item.type" -->
		<!-- 	block -->
		<!-- 	variant="flat" -->
		<!-- 	color="brown" -->
		<!-- 	mandatory -->
		<!-- 	flat -->
		<!-- > -->
		<!-- 	<v-btn variant="flat" class="flex-grow-1" value="package"> Package </v-btn> -->
		<!-- 	<v-btn variant="flat" class="flex-grow-1" value="pallet"> Pallet </v-btn> -->
		<!-- </v-btn-toggle> -->

		<div :class="{
			'body': true,
			'body_desktop': $vuetify.breakpoint.mdAndUp,
			'body_mobile': $vuetify.breakpoint.smAndDown,
		}">

			<template v-if="shipmentMethod === 'air'">
				<v-text-field v-model="item.weight" @input="item.weight = validateNumber($event)"
					label="Weight (lb)" type="number"  class="weight-input">
					<template v-slot:append>
						lb
					</template>
				</v-text-field>
			</template>
			<div v-else :class="{
				'volume': $vuetify.breakpoint.smAndDown,
				'volume_desktop': $vuetify.breakpoint.mdAndUp,
			}">
				<v-text-field v-model="item.width" @input="item.width = validateNumber($event)"
					label="Width (in)" type="number"  class="dimension-input">
					<template v-slot:append>
						in
					</template>
				</v-text-field>

				<v-text-field v-model="item.height" @input="item.height = validateNumber($event)"
					label="Height (in)" type="number"  class="dimension-input">
					<template v-slot:append>
						in
					</template>
				</v-text-field>

				<v-text-field v-model="item.depth" @input="item.depth = validateNumber($event)" label="Depth
					(in)" type="number"  class="dimension-input">
					<template v-slot:append>
						in
					</template>
				</v-text-field>

			</div>
			<div class="volume_result" v-if="shipmentMethod === 'ocean'">
				<span class="title">Volume: </span>
				<span class="value subheading">{{ cubicFeet.toFixed(2) }} Cubic Feet</span>
				<!-- <span class="subtitle blue-grey--text text--lighten-1"> -->
				<!-- 	<v-icon color="blue-grey lighten-3">mdi-information-outline</v-icon> -->
				<!-- 	Customs fee and CIF not included -->
				<!-- </span> -->
			</div>

			<div class="price">
				<v-text-field v-model="item.invoiceTotal" @input="item.invoiceTotal = validateNumber($event)"
					label="Invoice Total" type="number" class="dollar_align">
					<template v-slot:prepend-inner>
						$
					</template>
				</v-text-field>
				<v-text-field v-model="item.count" @input="item.count = validateIntegerNumber($event)"
					:label="item.type === 'package' ? 'No. Packages' : 'No. Pallets'" type="number"
					class="small-input">
				</v-text-field>

			</div>

			<div :class="{
				'result': true,
				'result_desktop': $vuetify.breakpoint.mdAndUp,
			}">
				<div style="">
					<span class="body-1">Freight Charge:</span> {{ formatCost(freightCharge) }}
				</div>
				<div>
					<span class="body-1">Warehouse Fee:</span> {{ formatCost(warehouseFee) }}
				</div>
				<div style="">
					<span class="body-1">Import Duty(@ 22%):</span> {{ formatCost(customsFee) }}
				</div>
				<div v-if="isFirst" style="">
					<span class="body-1">Custom Broker Fee:</span> {{ formatCost(customBrokerFee) }}
				</div>
				<div v-if="shipmentMethod === 'ocean' && isFirst">
					<span class="body-1">Port Fee:</span> {{ formatCost(portFee) }}
				</div>
				<div v-if="shipmentMethod === 'ocean' && isFirst">
					<span class="body-1">Insurance:</span> {{ formatCost(insurance) }}
				</div>
				<!-- <div style="grid-column: span 2/ span 2"> -->
				<!-- 	<span class="body-1">Goverment Fees:</span> {{ govFees.toFixed(2) }}$  -->
				<!-- 	<span class="caption blue-grey--text text--lighten-1">+ Customs fee and CIF</span> -->
				<!-- </div> -->

			</div>

		</div>

		<span class="red--text text--darken-2 subtitle text-center">

			<v-icon color="red darken-2">mdi-information-outline</v-icon>
			Import duty is generally calculated at a rate of 22% on importation of most goods, including on the freight charge. 
			Please refer to the
			<a href="https://www.gov.ky/cbc/info/latest-guides">Cayman Islands Customs website</a> 
			for the latest list of tariff rates.
		</span>
		<div style="display:flex;justify-content: space-between;flex-direction:row-reverse;">
			<!-- <span class="blue-grey--text text--lighten-1 subtitle"> -->
			<!---->
			<!-- 	<v-icon color="blue-grey lighten-3">mdi-information-outline</v-icon> -->
			<!-- 	Import duty is paid, generally at a rate of 22% on importation of most goods, including on the freight charge. -->
			<!-- 	Please refer to  -->
			<!-- 	<a href="https://www.gov.ky/cbc/info/latest-guides">the Cayman Islands Customs website</a>  -->
			<!-- 	for the latest list of tariff rates. -->
			<!-- </span> -->
			<!-- <div :class="{ -->
			<!-- 	'total': true, -->
			<!-- 	'total_desktop': $vuetify.breakpoint.mdAndUp, -->
			<!-- }"> -->
			<!-- 	<span class="title">Total Estimate: </span> -->
			<!-- 	<span class="value ">${{ totalFees.toFixed(2) }}</span> -->
				<!-- <span class="subtitle blue-grey--text text--lighten-1"> -->
				<!-- 	<v-icon color="blue-grey lighten-3">mdi-information-outline</v-icon> -->
				<!-- 	Customs fee and CIF not included -->
				<!-- </span> -->
			<!-- </div> -->
		</div>
		<div style="display:flex;justify-content: space-between;gap:0.5rem;" :class="{
				'flex-column-reverse ga-4': $vuetify.breakpoint.smAndDown,
			}">
			<v-btn
				v-if="isLast"
				@click="$emit('addNew')"
				small
				outlined
				color="brown"
			>
				<v-icon dark>
					mdi-plus
				</v-icon>
				Add Package
			</v-btn>
			<v-btn
				@click="$emit('delete')"
				small
				outlined
				color="brown"
			>
				<v-icon dark>
					mdi-minus
				</v-icon>
				Remove package
			</v-btn>
		</div>
		<v-divider></v-divider>
  </div>
</template>

<style>

.dollar_align .v-input__prepend-inner {
	align-self: flex-end;
	padding-bottom: 0.5rem;
}

.cnt {
	padding: 0.5rem;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	/* max-width: ; */
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: stretch;
}

.body {
	display: grid;
	/* grid-template-rows: repeat(3, minmax(1fr)); */
	grid-template-columns: 2fr;
	gap: 0.5rem;
}

.body_mobile {
	grid-template-columns: 1fr;
}

.body_desktop {
	grid-template-columns: 2fr;
}

.volume {
	/* flex-direction: row; */
	/* flex-wrap: wrap; */

	display: grid;
	grid-template-rows: 1fr 1fr 1fr;
	gap: 0.5rem;
}

.volume_desktop {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 0.5rem;
}


.price {
	/* grid-row-start: 2; */
	/* grid-column-start: 1; */

	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	/* align-items: center; */
	gap: 1rem;
}


.weight-input {
}

.dimension-input {
	flex-grow: 1;
}

.small-input {
	max-width: 100px;
	flex-grow: 1;
}
.big-input {
	max-width: 176px;
}

.result_desktop {
	/* grid-row: span 2 / span 2; */
	grid-template-columns: 1fr 1fr;

	max-width: 60%;
	margin: 0 auto;
}

.result {
	display: grid;
	/* grid-template-columns: 1fr 1fr; */
	gap: 0.5rem;
}

.total_desktop {
	/* grid-row-start: 3; */
	/* grid-column-start: 2; */

}

.total {
	align-self: center;
	text-align: center;
	margin-top: 0.5rem;
}

.total .title {
	font-size: 2rem !important;
	font-weight: semibold !important;
}
.total .value {
	font-size: 2.5rem !important;
	font-weight: bold !important;

	color: #D32F2F ;
}
.subtitle {
	font-size: 0.8;
	/* max-width: 50%; */
	text-align: justify;
}


.volume_result {
}
.volume_result .title {
	font-size: 1rem !important;
	font-weight: normal;
}
.volume_result .value {
	font-size: 1.2rem;
	font-weight: semibold;
}


</style>

<script>

	import { calcFreightCarge, calcTotalGovFees, calcPortFee, calcInsurance, calcVolume, calcBrokerFee,
		calcMiaWarehouseFee, calcTotalFees, calcCustomsFee, formatCost, } from './utils'

export default {
  name: 'Item',

  components: {
  },

  props: {
		item: Object,
		isLast: Boolean,
		shipmentMethod: String,

		isFirst: Boolean,

		customBrokerFee: Number,
		portFee: Number,
		insurance: Number,
  },


  mounted: function () {
  },

  computed: {
		freightCharge: function() {
			return calcFreightCarge(this.shipmentMethod, this.item)
		},
		customsFee: function() {
			return calcCustomsFee(this.shipmentMethod, this.item)
		},
		// insurance: function() {
		// 	return calcInsurance(this.shipmentMethod, this.item)
		// },
		cubicFeet: function() {
			return calcVolume(this.shipmentMethod, this.item)
		},
		// portFee: function() {
		// 	return calcPortFee(this.shipmentMethod, this.item)
		// },
		warehouseFee: function() {
			return calcMiaWarehouseFee(this.shipmentMethod, this.item)
		},
		// customBrokerFee: function() {
		// 	return calcBrokerFee(this.shipmentMethod, this.item)
		// },
		govFees: function() {
			return calcTotalGovFees(this.shipmentMethod, this.item)
		},

		totalFees: function() {
			return calcTotalFees(this.shipmentMethod, this.item)
		},
		
  },

  methods: {
		validateNumber(num) {
			if (num.length < 1) return 0
			if (num.endsWith('.')) return num

			const cleanNum = num.replace(/[^\d.]/, '')
			const ret = Number(cleanNum)
			if (isNaN(ret)) return 0

			return ret
		},
		validateIntegerNumber(num) {
			if (num.length < 1) return 0

			const cleanNum = num.replace(/[^\d]/, '')
			const ret = Number(cleanNum)
			if (isNaN(ret)) return 0
			return ret
		},
		formatCost(num) { return formatCost(num) }
  },
};
</script>
